<template>
    <div class="w-100">
        <div class="w-100 pt-3">
            <b-button size="sm" variant="primary" v-b-modal.dpad1Modal>
                {{$t("dpad.addDpad1")}}
            </b-button>
        </div>
        <b-row class="pt-1">
            <b-col lg="3">
                <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    :placeholder="$i18n.locale()=='kz' ? 'Іздеу' : 'Поиск'"
                ></b-form-input>
            </b-col>
            <b-col lg="3">
                <select required id="depId" 
                    class="form-control" 
                    v-model.number="depId" @change="sysChange()">
                    <option value=0>
                        {{ $i18n.locale()=='kz' ? 'Таңдаңыз...' : 'Выберите...' }}
                    </option>
                    <option v-for="t in departments" :value="t.depId">
                        {{ $i18n.locale()=='kz' ? t.depName :t.depNameRu}} 
                    </option>
                </select>
            </b-col>

            <b-col lg="2">
                <select required id="typeId" 
                    class="form-control" 
                    v-model.number="typeId" @change="sysChange()">
                    <option value=0>
                        {{ $i18n.locale()=='kz' ? 'Таңдаңыз...' : 'Выберите...' }}
                    </option>
                    <option v-for="t in types" :value="t.typeId">
                        {{ $i18n.locale()=='kz' ? t.typeName :t.typeNameRu}} 
                    </option>
                </select>
            </b-col>

            <b-col lg="2">
                <select required id="tenderType" 
                    class="form-control" 
                    v-model.number="tenderType" @change="sysChange()">
                    <option value=0>
                        {{ $i18n.locale()=='kz' ? 'Таңдаңыз...' : 'Выберите...' }}
                    </option>
                    <option value=1>
                        Открытый тендер/аукцион tender
                    </option>
                    <option value=2>
                        Запрос ценовых предложений    
                    </option>
                </select>
            </b-col>


            <b-col lg="2" class="pt-3 text-right">
                <strong>
                    {{$i18n.locale()=='kz' ? 'Жалпы саны:' : 'Общее число'}}
                </strong> {{totalRows}}  
            </b-col>
            <b-col lg="12">
                <b-table  
                    size="sm"
                    ref="dTable"
                    striped hover selectable
                    :items="dpadProvider" 
                    :fields="fields"
                    :busy.sync="isBusy"
                    :current-page="currentPage"
                    :per-page="perPage"
                    table-variant='light'
                    :filter="filter"
                    :select-mode="selectMode"
                    responsive
                    
                    @row-selected="onRecordSelected"
                    >
                    <template v-slot:cell(ID)="{ rowSelected }">
                    <template v-if="rowSelected">
                        <span aria-hidden="true">&check;</span>
                        <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">Not selected</span>
                    </template>
                    </template>
                    <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Жүктелуде...</strong>
                    </div>
                    </template>     
                    <template #head(depName)="data">
                        <div class="text-left text-info ">{{$t(data.label)}}</div>
                    </template>
                    <template #head(typeName)="data">
                        <div class="text-left text-info ">{{$t(data.label)}}</div>
                    </template>
                    <template #head(dName)="data">
                        <div class="text-left text-info ">{{$t(data.label)}}</div>
                    </template>
                    <template #head(tenderNumber)="data">
                        <div class="text-left text-info ">{{$t(data.label)}}</div>
                    </template>
                    <template #head(tenderPrice)="data">
                        <div class="text-left text-info ">{{$t(data.label)}}</div>
                    </template>
                    <template #head(bankPrice)="data">
                        <div class="text-left text-info ">{{$t(data.label)}}</div>
                    </template>
                    <template #head(beginDate)="data">
                        <div class="text-left text-info ">{{$t(data.label)}}</div>
                    </template>
                    <template #head(endDate)="data">
                        <div class="text-left text-info ">{{$t(data.label)}}</div>
                    </template>
                    <template #head(description)="data">
                        <div class="text-left text-info ">{{$t(data.label)}}</div>
                    </template>
                    <template #head(tenderType)="data">
                        <div class="text-left text-info ">{{$t(data.label)}}</div>
                    </template>
                    <template #head(actions)="data">
                        <div class="text-left text-info ">{{$t(data.label)}}</div>
                    </template>

                    <template v-slot:cell(depName)="row">
                        <div v-if="$i18n.locale()=='kz'">
                            <b-badge  v-for="(d,di) in row.item.depName.split(',')" :key="di">
                                {{di+1+'.'+d}}
                            </b-badge>
                        </div>
                        <div v-else>
                            <b-badge v-for="(d,di) in row.item.depNameRu.split(',')" :key="di">
                                {{di+1+'.'+d}}
                            </b-badge>
                        </div>
                    </template>
                    <template v-slot:cell(typeName)="row">
                        <b-badge variant="info">
                            <span v-if="row.item.typeName">
                                {{$i18n.locale()=='kz' ? row.item.typeName : row.item.typeNameRu}}
                            </span>
                        </b-badge>
                    </template>
                    <template v-slot:cell(tenderPrice)="row">
                        <b-alert show variant="danger">
                            {{row.item.tenderPrice}}
                        </b-alert>
                    </template>
                    <template v-slot:cell(tenderType)="row">
                        <span v-if="row.item.tenderType==1">Открытый тендер/аукцион </span>
                        <span v-else>Запрос ценовых предложений</span>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <div class="w-100 text-center">
                            <b-icon variant="danger" icon="trash-fill" scale="1.5" class="border rounded mr-2"></b-icon>
                            <b-icon variant="success" icon="pencil-fill" scale="1.5" class="border rounded"></b-icon>
                        </div>
                    </template>
                </b-table>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="my-0"
                ></b-pagination>
            </b-col>
        </b-row>
        <DpadForm1 ref="dpadForm1" :departments="departments" :types="types" :sysChange="sysChange"></DpadForm1>
    </div>
</template>
<script>
    import axios from 'axios';
    import {apiDomain,getHeader,getMultipartHeader,getDownloadHeader} from "@/config/config";
    import vue from 'vue';
    import DpadForm1 from './DpadForm1.vue';
    export default{
        name:"DpadList1",
        props:["pId"],
        components:{
            DpadForm1
        },
        data(){
            return {
                fields: [
                    {
                        key: 'dId',
                        label: 'ID',
                    },
                    {
                        key:"depName",
                        label: 'project.dpad.depName',
                    },
                    {
                        key:"typeName",
                        label: 'project.dpad.typeName',
                    },
                    {
                        key: 'dName',
                        label: 'project.dpad.dName',
                    },
                    
                    
                    {
                        key: 'tenderPrice',
                        label: 'project.dpad.tenderPrice',
                    },
                    {
                        key: 'bankPrice',
                        label: 'project.dpad.bankPrice',
                    },
                    {
                        key:"tenderType",
                        label: 'project.dpad.tenderType',
                    },
                    {
                        key: 'beginDate',
                        label: 'project.dpad.beginDate',
                    },
                   
                    
                    {
                        key:"actions",
                        label: 'project.file.actions',
                    }
                
                ],
                isBusy:false,
                totalRows:0,
                currentPage: 1,
                perPage: 20,
                tableVariant:'light',
                filter:"",
                selectMode:'single',
                selectedRows:[],
                types:[],
                departments:[],
                typeId:0,
                tenderType:0,
                depId:0
            }
        },
        methods:{
            sysChange(){
                this.$refs.dTable.refresh();  
            }, 
            onRecordSelected(items){
                this.selectedRows=items;
            },
            deleteDpad(fileId){
                if(confirm(this.$t("project.delFileConfirm"))){
                    axios.post(apiDomain+'/p/deleteprojectfile',{"fileId":fileId},{headers:getHeader()})
                    .then(()=>{
                        this.$refs.fileTable.refresh();
                    }).catch(error => {
                        alert(error.message);
                    })
                }
            },
           
            dpadProvider(ctx){
                this.isBusy = false
                ctx.typeId=this.typeId;
                ctx.tenderType=this.tenderType;
                ctx.dpadType=1;
                ctx.depId=this.depId;
                let promise = axios.post(apiDomain+'/dpad/list',ctx,{headers:getHeader()});
                    return promise.then((response) => {
                    const result = response.data;
                    this.isBusy = false
                    this.totalRows=result.recordCount;      
                    return(result.items)
                }).catch(error => {
                    this.isBusy = false
                    return []
                })
            },
            getTypes(){
                axios.post(apiDomain+'/dpad/ptypes',{}, {headers:getHeader()})
                .then((response)=>{
                    this.types=response.data;
                }).catch(error => {
                    alert(error.message);
                })
            },
            getDepartments(){
                axios.post(apiDomain+'/dpad/departments',{}, {headers:getHeader()})
                .then((response)=>{
                    this.departments=response.data;
                }).catch(error => {
                    alert(error.message);
                })
            }
        },
        created(){
            this.getTypes();
            this.getDepartments();
        }
    }
</script>